import * as React from "react";
const MembershipPaymentsIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={21}
    fill="none"
    {...props}
  >
    <mask
      id="aMembershipPaymentsIcon"
      width={20}
      height={21}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "alpha",
      }}
    >
      <path fill="#D9D9D9" d="M0 .5h20v20H0z" />
    </mask>
    <g mask="url(#aMembershipPaymentsIcon)">
      <path
        fill={props.fill}
        d="M9.167 17.167v-1.25a3.484 3.484 0 0 1-1.99-.948c-.562-.542-.976-1.28-1.24-2.219l1.542-.625c.222.75.546 1.319.97 1.708.424.389.965.584 1.625.584.555 0 1.027-.125 1.416-.375.389-.25.583-.639.583-1.167 0-.472-.146-.844-.437-1.115-.292-.27-.973-.58-2.042-.927-1.152-.361-1.94-.77-2.365-1.229-.424-.458-.636-1.035-.636-1.73 0-.833.271-1.476.813-1.927a3.414 3.414 0 0 1 1.583-.76V3.833h1.667V5.16c.597.083 1.104.287 1.521.614.417.326.729.726.938 1.2l-1.521.645c-.167-.334-.38-.581-.636-.74-.257-.16-.594-.24-1.01-.24-.597 0-1.05.128-1.365.386-.313.257-.47.583-.47.98 0 .444.205.795.615 1.052.41.257 1.122.528 2.135.813 1.028.292 1.774.719 2.24 1.281.464.562.697 1.24.697 2.031 0 .931-.281 1.635-.844 2.114a4.166 4.166 0 0 1-2.156.97v1.3H9.167Z"
      />
    </g>
  </svg>
);
export default MembershipPaymentsIcon;
